/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2023, Zumper
 */

import type { AutocompleteResult } from '@zcode/bizos'
import {
  AUTOCOMPLETE_ADDRESS,
  AUTOCOMPLETE_BUILDING,
  AUTOCOMPLETE_NEIGHBORHOOD,
  AUTOCOMPLETE_POSTCODE,
} from '@zcode/nr/es/shared/components/Autocomplete/constants'

export const getCommaSeparatedText = (string1?: string | null, string2?: string | null) => {
  return [string1, string2].filter(Boolean).join(', ')
}

export const getSelectedLocationText = (result: AutocompleteResult) => {
  const { city, state, name, type } = result
  const cityAndState = getCommaSeparatedText(city, state)
  if (
    type === AUTOCOMPLETE_ADDRESS ||
    type === AUTOCOMPLETE_BUILDING ||
    type === AUTOCOMPLETE_POSTCODE ||
    type === AUTOCOMPLETE_NEIGHBORHOOD
  ) {
    return getCommaSeparatedText(name, cityAndState)
  }
  return cityAndState
}
